export default "__VITE_ASSET__529d6895__"